import { useMemo } from 'react';
import { useUsers } from './useUsers';
import type { User } from '../model';

const emptyAdvisors: User[] = [];

const SERVICE_ADVISOR_ROLES = new Set(['admin', 'service_advisor']);

/**
 * Hook to get service advisors (users with role 'service_advisor' or 'admin') as User instances.
 * Admins are included because they can act as service advisors.
 */
export const useServiceAdvisors = () => {
  const query = useUsers();

  const advisors = useMemo(() => {
    if (!query.data) {
      return emptyAdvisors;
    }

    return query.data.filter((user) => user.role !== undefined && SERVICE_ADVISOR_ROLES.has(user.role));
  }, [query.data]);

  return {
    ...query,
    data: advisors,
  };
};
